import React from 'react';
import Section from './Section';

const Cursos = () => {
  const cursoLink = 'https://univassouras.edu.br/especializacao-e-mba/';

  const cards = [
    {
      img: '/imagem/curso/credito carbono.png',
      link: 'https://www.sympla.com.br/evento-online/creditos-de-carbono-em-agricultura-florestas-e-outros-usos-da-terra-afolu/3558406',
    },
    {
      img: '/imagem/curso/credito rural.png',
      link: 'https://www.sympla.com.br/evento-online/credito-rural-do-zero-a-pratica-fundamentos-linhas-e-projetos/3550688',
    },
    {
      img: '/imagem/curso/pagamento-por-servicos-ambientais-psa.png',
      link: 'https://www.sympla.com.br/evento-online/pagamento-por-servicos-ambientais-psa-conceitos-legislacao-e-aplicacoes/3568601',
    },
    { img: '/imagem/curso/curso-01.jpeg', link: cursoLink },
    { img: '/imagem/curso/curso-02.jpeg', link: cursoLink },
    { img: '/imagem/curso/curso-03.jpeg', link: cursoLink },
    { img: '/imagem/curso/curso-04.jpeg', link: cursoLink },
    { img: '/imagem/curso/curso-05.jpeg', link: cursoLink },
    { img: '/imagem/curso/curso-06.jpeg', link: cursoLink },
  ];

  const [index, setIndex] = React.useState(0);

  const prev = () => setIndex((i) => (i - 1 + cards.length) % cards.length);
  const next = React.useCallback(() => {
    setIndex((i) => (i + 1) % cards.length);
  }, [cards.length]);

  React.useEffect(() => {
    const interval = setInterval(next, 9000);
    return () => clearInterval(interval);
  }, [next]);

  const getVisibleCards = () => {
    const prevIndex = (index - 1 + cards.length) % cards.length;
    const nextIndex = (index + 1) % cards.length;

    return [
      { card: cards[prevIndex], position: 'left' },
      { card: cards[index], position: 'center' },
      { card: cards[nextIndex], position: 'right' },
    ];
  };

  const visibleCards = getVisibleCards();

  return (
    <Section id="cursos" bgClass="bg-gray-50" title="Cursos e Capacitações">
      <p className="max-w-3xl mx-auto text-center mb-6 text-gray-700 px-4">
        A AEAGO promove cursos, palestras e treinamentos. Acompanhe os cursos
        disponíveis e mantenha-se preparado para os desafios do campo e do
        mercado.
      </p>

      <div className="relative max-w-6xl mx-auto px-2 sm:px-4">
        <div className="flex items-center justify-center gap-2 sm:gap-4">
          <button
            onClick={prev}
            className="flex-shrink-0 bg-navy text-white p-2 sm:p-2.5 rounded-full hover:bg-secondary transition-colors z-20 text-xl sm:text-2xl"
            aria-label="Anterior"
          >
            &#8249;
          </button>

          {/* carousel container */}
          <div className="flex-1 flex items-center justify-center min-h-[460px] sm:min-h-[520px] md:min-h-[560px]">
            {/* Mobile: exibe apenas o card central */}
            <div className="sm:hidden flex justify-center w-full">
              {(() => {
                const CardTag = cards[index].link ? 'a' : 'div';
                const linkProps = cards[index].link
                  ? { href: cards[index].link, target: '_blank', rel: 'noopener noreferrer' }
                  : {};
                return (
                  <CardTag
                    {...linkProps}
                    className="w-[260px] xs:w-[280px] aspect-[9/16] bg-white shadow-2xl rounded-xl overflow-hidden flex items-center justify-center transition-transform hover:scale-[1.02]"
                  >
                    <img
                      src={process.env.PUBLIC_URL + encodeURI(cards[index].img)}
                      alt={`Curso ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </CardTag>
                );
              })()}
            </div>

            {/* Tablet/Desktop: exibe 3 cards */}
            <div className="hidden sm:flex items-center justify-center gap-4 md:gap-6 relative">
              {visibleCards.map((item, idx) => {
                const { card, position } = item;
                const isCenter = position === 'center';
                const CardTag = card.link ? 'a' : 'div';
                const linkProps = card.link
                  ? { href: card.link, target: '_blank', rel: 'noopener noreferrer' }
                  : {};

                return (
                  <div
                    key={idx}
                    className={`transition-all duration-700 ease-in-out ${
                      isCenter
                        ? 'scale-100 opacity-100 z-10'
                        : 'scale-90 opacity-70 z-0'
                    }`}
                  >
                    <CardTag
                      {...linkProps}
                      className="w-[220px] md:w-[260px] lg:w-[280px] aspect-[9/16] bg-white shadow-2xl rounded-xl overflow-hidden flex items-center justify-center transition-transform hover:scale-[1.02]"
                    >
                      <img
                        src={process.env.PUBLIC_URL + encodeURI(card.img)}
                        alt="Curso"
                        className="w-full h-full object-cover"
                      />
                    </CardTag>
                  </div>
                );
              })}
            </div>
          </div>

          <button
            onClick={next}
            className="flex-shrink-0 bg-navy text-white p-2 sm:p-2.5 rounded-full hover:bg-secondary transition-colors z-20 text-xl sm:text-2xl"
            aria-label="Próximo"
          >
            &#8250;
          </button>
        </div>

        {/* pagination dots */}
        <div className="flex justify-center mt-8 space-x-2">
          {cards.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Ir para curso ${i + 1}`}
              className={`h-2.5 w-2.5 rounded-full transition-all ${
                i === index ? 'bg-navy scale-110' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>

      <div className="text-center mt-8">
        <a
          href="https://wa.me/5562991549668?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20os%20cursos"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-navy text-white py-2 px-6 rounded-full border border-gold hover:bg-secondary transition-colors"
        >
          Quero saber mais
        </a>
      </div>
    </Section>
  );
};

export default Cursos;
